import { createAction } from 'redux-act';
import { ISharedNote } from '@app-types/websocket/sharedinfo.types';

export const localSave = createAction<ISharedNote>('Local save');
export const localDel = createAction<number>('Local delete');
export const updateSharedNote = createAction<ISharedNote>('Update shared note');
export const seenSharedNote = createAction<number>('Seen shared note');
export const deleteSharedNote = createAction<number>('Delete shared note');
export const updateSharedNoteOrder = createAction<number[]>('Update shared note order');



// WEBPACK FOOTER //
// ./src/services/sharednote/sharednote.actions.ts